module.exports = __webpack_public_path__ + "static/devfest-b5d1fa9740b55fc9e0e2d763da1f01b4.png";